import { render, staticRenderFns } from "./BlogQuote.vue?vue&type=template&id=dbac9570&scoped=true&"
import script from "./BlogQuote.vue?vue&type=script&lang=js&"
export * from "./BlogQuote.vue?vue&type=script&lang=js&"
import style0 from "./BlogQuote.vue?vue&type=style&index=0&id=dbac9570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbac9570",
  null
  
)

export default component.exports